export enum CreateSectionFormFieldEnum {
    TITLE = 'title',
    BODY = 'body'
}